@if (visible) {
  <span
    class="annex-badge"
    [class.annex-badge--green]="badgeColor === 'green'"
    [class.annex-badge--orange]="badgeColor === 'orange'"
    [class.annex-badge--red]="badgeColor === 'red'"
    [matTooltip]="tooltipText"
    matTooltipClass="annex-badge-tooltip"
  >A</span>
}
